import React, { forwardRef } from 'react';
import { Text, StyleSheet } from 'react-native';
import { DRNUtil } from '@traveloka/district-util';
import { BMPrimitives, useBMTheme } from '../../theme';
import getDefaultAccesibilityProps from './utils/getDefaultAccesibilityProps';
const BaseText = forwardRef((props, ref) => {
    const { BMComponents } = useBMTheme();
    const { style, variant = 'uiNormal', ink = 'BMStyleTextInkPrimary', ...rest } = props;
    const inkColor = BMComponents[ink];
    const textStyle = [{ color: inkColor }, BMPrimitives.BMTypography[variant], styles.text, style];
    let textProps = {
        ...rest,
        style: textStyle,
    };
    if (DRNUtil.isWeb()) {
        const defaultAccessibilityProps = getDefaultAccesibilityProps(variant);
        // Ignore to allow assigning non standard react-native props
        // @ts-ignore
        textProps = {
            ...defaultAccessibilityProps,
            ...textProps,
        };
    }
    return <Text {...textProps} ref={ref}/>;
});
const styles = StyleSheet.create({
    text: {
        // To support RTL, give a default value left of textAlign
        textAlign: 'left',
        // to support monospace
        fontVariant: ['tabular-nums'],
    },
});
export default BaseText;
